/* export function login(state, auth) {
    state.status = true
} */

export function cargarEstados(state, estados) {
    state.estados = estados
}

/* export function logout(state) {
    Object.assign(state.user_logued, defaultUserLogued())
    state.authentication = { email: "", password: "" },
        state.status = false
}

export function setUserLogued(state, user_logued) {
    state.user_logued = user_logued
} */